import { useEffect } from 'react';

const SEOHead = ({ 
  title = "Free YouTube & TikTok Video Downloader - HD, No Watermark | YT DOWN",
  description = "Download YouTube and TikTok videos in HD quality without watermarks. Free online video downloader - fast, secure, no registration required. Download MP4, MP3, 4K videos instantly on any device.",
  keywords = "youtube downloader, tiktok downloader, video downloader, download youtube videos, download tiktok videos, no watermark, hd video download, free video downloader, youtube to mp4, youtube to mp3, tiktok video download, online video downloader, 4k video downloader, youtube shorts downloader, save youtube videos, save tiktok videos, mp4 downloader, mp3 converter, video download online, free youtube downloader, free tiktok downloader",
  image = "/logo512.png",
  url = "https://digimac.pro/"
}) => {
  useEffect(() => {
    // Set document title
    document.title = title;

    // Set or update meta tags
    const setMetaTag = (name, content, isProperty = false) => {
      const attribute = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      
      element.setAttribute('content', content);
    };

    // Update canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    // Primary meta tags
    setMetaTag('title', title);
    setMetaTag('description', description);
    setMetaTag('keywords', keywords);
    
    // Author & SEO
    setMetaTag('author', 'YT DOWN');
    setMetaTag('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    setMetaTag('googlebot', 'index, follow');
    setMetaTag('language', 'English');
    setMetaTag('revisit-after', '7 days');
    setMetaTag('rating', 'general');
    
    // Open Graph meta tags (Facebook, LinkedIn)
    setMetaTag('og:type', 'website', true);
    setMetaTag('og:url', url, true);
    setMetaTag('og:title', title, true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:image', `${url}${image}`, true);
    setMetaTag('og:site_name', 'YT DOWN', true);
    setMetaTag('og:locale', 'en_US', true);
    
    // Twitter Card meta tags
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:url', url);
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', `${url}${image}`);
    
    // Additional SEO meta tags
    setMetaTag('application-name', 'YT DOWN');
    setMetaTag('apple-mobile-web-app-title', 'YT DOWN');
    setMetaTag('theme-color', '#667eea');
    
  }, [title, description, keywords, image, url]);

  return null; // This component doesn't render anything
};

export default SEOHead;
